import { IDisplaysListResponse } from '@/api/services/displays/displaysService'
import { Button } from '@/components/ui/common/Button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/common/Popover'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '@/components/ui/common/Table'
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard'
import paths from '@/router/data/paths'
import { Check, Copy, ExternalLink, MoreHorizontal } from 'lucide-react'
import { memo } from 'react'
import { Link } from 'react-router-dom'
import DisplayCreate from './DisplayCreate'
import DisplayDelete from './DisplayDelete'
import DisplayEdit from './DisplayEdit'

const DisplayRow = ({ display }: { display: IDisplaysListResponse['items'][number] }) => {
  const { state, copyToClipboard } = useCopyToClipboard()

  return (
    <TableRow key={display.id}>
      <TableCell className="text-base font-medium">{display.name}</TableCell>
      <TableCell className="text-base">
        {display.advertisementId ? (
          <Link
            className="text-primary underline underline-offset-4"
            to={paths.GRAPHICS_ID.replace(':id', display.advertisementId)}
          >
            {display.advertisementId}
          </Link>
        ) : (
          'Brak'
        )}
      </TableCell>
      <TableCell className="text-base">{display?.resolution || 'Brak'}</TableCell>
      <TableCell>
        <div className="flex items-center gap-3">
          <a
            href={`https://api.shopadverts.pl/api/v1/advertisement-displays/${display.id}/html`}
            rel="noreferrer"
            target="_blank"
          >
            <Button
              onClick={(e) => {
                e.stopPropagation()
              }}
              size={'icon'}
              variant={'ghost'}
            >
              <ExternalLink />
            </Button>
          </a>
          <Button
            onClick={(e) => {
              e.stopPropagation()
              copyToClipboard(
                `https://api.shopadverts.pl/api/v1/advertisement-displays/${display.id}/html`
              )
            }}
            size={'icon'}
            variant={'ghost'}
          >
            {!!state ? <Check /> : <Copy />}
          </Button>
        </div>
      </TableCell>
      <TableCell className="">
        <Popover>
          <PopoverTrigger asChild>
            <Button
              onClick={(e) => {
                e.stopPropagation()
              }}
              size={'icon'}
              variant={'ghost'}
            >
              <MoreHorizontal />
            </Button>
          </PopoverTrigger>
          <PopoverContent className="mr-4 w-48" onClick={(e) => e.stopPropagation()}>
            <div className="flex w-full flex-col border-t border-b border-gray-100">
              <DisplayEdit
                advertisementId={display.advertisementId}
                id={display.id}
                name={display.name}
              />
              <DisplayDelete id={display.id} />
            </div>
          </PopoverContent>
        </Popover>
      </TableCell>
    </TableRow>
  )
}

function DisplayList({ data }: { data: IDisplaysListResponse | undefined }) {
  if (!data) return null

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-row items-center justify-between">
        <h1 className="text-2xl font-semibold">Sklep słoneczko</h1>
        <DisplayCreate />
      </div>
      {!data.items.length ? (
        <div className="flex h-92 w-full items-center justify-center">
          <span className="text-2xl">Brak wyświetlaczy</span>
        </div>
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Nazwa</TableHead>
              <TableHead>Przypisana reklama</TableHead>
              <TableHead>Rozdzielczość</TableHead>
              <TableHead>Wyświetlacz</TableHead>
              <TableHead className="w-[60px]"></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.items.map((display) => (
              <DisplayRow display={display} key={display.id} />
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  )
}

export default memo(DisplayList)
